import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import { Link, withRouter } from 'react-router-dom';

import logo from '@src/img/logos/foremost-logo.svg';

import Menu from './MobileHeaderMenu';
import Search from '../HeaderMenuTop/SearchItem';

class MobileHeader extends React.PureComponent {
    static propTypes = {
        height: PropTypes.number.isRequired,
        menus: PropTypes.arrayOf(PropTypes.object).isRequired,
        match: PropTypes.shape({
            url: PropTypes.string.isRequired,
        }),
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }).isRequired,
    };

    static getDerivedStateFromProps(props, state) {
        const { location: { pathname } } = props;

        if (state.pathname === pathname) {
            return null;
        }

        return {
            pathname,
            expanded: false,
        };
    }

    constructor(props) {
        super(props);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            pathname: props.location.pathname,
            expanded: false,
        };
    }

    handleOnMenuClick = () => {
        this.setState((state) => {
            return {
                expanded: !state.expanded,
            };
        });
    };

    render() {
        const { height, menus } = this.props;
        const { expanded } = this.state;

        return (
            <Row id="header-mobile-menu-row" className="header-mobile-menu-row">
                <Col>
                    <Container fluid className="p-0">
                        <Navbar collapseOnSelect className="p-0 shadow-sm" expanded={expanded} expand="lg">
                            <Navbar.Brand as={Link} to="/" className="pl-3 ml-2 mr-0" tabIndex={1000}>
                                <img src={logo} className="nav-brand-img d-inline-block align-middle" alt="Foremost Insurance Group" />
                                <>
                                    <span className="nav-brand-pipe align-middle" />
                                    <span className="nav-brand-title align-middle">
                                        Producer News Portal
                                    </span>
                                </>
                            </Navbar.Brand>
                            <Nav className="ml-auto my-2">
                                <Search />
                            </Nav>
                            <Navbar.Toggle className="m-3" aria-controls="basic-navbar-nav" tabIndex={1000} onClick={this.handleOnMenuClick} />
                            <Navbar.Collapse id="basic-navbar-nav" style={{ overflowY: 'auto', maxHeight: `${height - 72}px` }}>
                                <Nav className="border-0">
                                    <Menu menus={menus} />
                                </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </Container>
                </Col>
            </Row>
        );
    }
}

export default withRouter(MobileHeader);
